<template>
	<nav class="nav-bar">
		<div class="navbar-wrapper horizontal-center">
			<div v-if="$store.state.isNavBarMenuShow">
				<label class="burger" @click="isBurgerOpen = !isBurgerOpen" :class="{ 'is-active': isBurgerOpen }">
					<span class="top"></span>
					<span class="middle"></span>
					<span class="bottom"></span>
				</label>

				<img class="pc-logo" :src="require('@/assets/pc_menu_logo.svg')" />
			</div>

			<div class="space"></div>

			<img class="page-icon" :src="menuIcon" />
			<div class="page-title">{{ pageTitle }}</div>

			<div v-if="$store.state.isNavBarMenuShow" class="nav-menu" :class="{ 'is-active': isBurgerOpen }">
				<img class="sp-logo" :src="require('@/assets/sp_menu_logo.svg')" />

				<ul>
					<li class="horizontal-center" v-for="(row, index) in menus" :key="index">
						<a class="horizontal-center menu-item" @click="onMenuClick(row)">
							<img class="menu-icon" :src="require('@/assets/icons/' + row.icon + '.svg')"/>
							{{ row.title }}
						</a>
					</li>

					<li>
						<a href="#" class="logout" @click="onLogoutClick">ログアウト</a>
					</li>
				</ul>

			</div>
		</div>
	</nav>
</template>

<script>

export default {
	name: 'NavBar',
	props: {
	},
	data() {
		return {
			isBurgerOpen: false,
			pageTitle: '',
			icon: '',
			menus: [],
		}
	},
	created() {
		this.menus = [
			{
				title: 'ホーム',
				icon: 'home',
				linkName: 'top',
			},
			{
				title: 'チームトーク',
				icon: 'balloon',
				linkName: 'team-talk',
			},
			{
				title: 'コインを贈る',
				icon: 'coin',
				linkName: 'coin-present',
				callback: (() => this.$store.commit('disableCoinPresentDataRecovery')),
			},
			{
				title: '記事を書く',
				icon: 'news_edit',
				linkName: 'news-new',
			},
			{
				title: 'チームを作る',
				icon: 'team',
				linkName: 'team-new',
			},
			{
				title: '順位',
				icon: 'crown',
				linkName: 'ranking',
			},
			{
				title: 'みんなの記事',
				icon: 'news',
				linkName: 'news',
				callback: (() => this.$store.commit('disableNewsDataRecovery')),
			},
			{
				title: '7Coinsとは',
				icon: 'seven',
				linkName: 'about',
			},
			{
				title: '景品交換',
				icon: 'gift',
				linkName: 'prize',
			},
			{
				title: 'マイページ',
				icon: 'my_page',
				linkName: 'my-page',
			},
			{
				title: '獲得履歴',
				icon: 'gift',
				linkName: 'history',
			},
		];
	},
	computed: {
		menuIcon: function() {
			return this.icon ? require('@/assets/icons/' + this.icon + '.svg') : '';
		},
	},
	watch: {
		'$route' (to, from) {
			this.$utils.log(to);
			if (!this.$utils.isApp()) {
				if (to.meta.title) {
					this.pageTitle = to.meta.title;
				}
				if (to.meta.icon) {
					this.icon = to.meta.icon;
				} else {
					this.icon = '';
				}
			}
		}
	},
	mounted() {
	},
	methods: {
		onMenuClick: function(row) {
			this.isBurgerOpen = false;

			if (row.callback) {
				this.$utils.log('onMenuClick callback!!!!!');
				row.callback();
			}

			this.$router.push({ name: row.linkName });
		},
		onLogoutClick: function() {
			this.isBurgerOpen = false;
			this.$auth.logout();
			this.$router.push({ name: 'login' });
		},
	},
}
</script>
